import './MobileLogsBundlesTabs.scss';

import { IonButton, IonLabel, useIonRouter } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { JobMessages } from '../intl/JobMessages';
import { AppRouteConstants } from '../pages/app-layout/AppRouteConstants';

export const MobileLogsBundlesTabs: React.FC = () => {
  const { formatMessage } = useIntl();
  const router = useIonRouter();

  const selected = router.routeInfo.pathname.startsWith(AppRouteConstants.BundlesList)
    ? AppRouteConstants.BundlesList
    : AppRouteConstants.LogsList;

  return (
    <div className="jobs-tab-navigation">
      <IonButton
        className={selected === AppRouteConstants.LogsList ? 'selected' : undefined}
        fill="clear"
        color="medium"
        routerLink={AppRouteConstants.LogsList}
        routerDirection="root"
      >
        <IonLabel>{formatMessage(JobMessages.logsTitle)}</IonLabel>
      </IonButton>

      <IonButton
        className={selected === AppRouteConstants.BundlesList ? 'selected' : undefined}
        fill="clear"
        color="medium"
        routerLink={AppRouteConstants.BundlesList}
        routerDirection="root"
      >
        <IonLabel>{formatMessage(JobMessages.bundlesTitle)}</IonLabel>
      </IonButton>
    </div>
  );
};
